import { createReducer } from './index';
import { fromJS } from 'immutable';
import * as ActionTypes from '../actions/types';

const INITIAL_STATE = fromJS({
  drawerOpen: false
});

function openDrawer(state, action){
  return state.set('isDrawerOpen', true);
}

function closeDrawer(state, action){
  return state.set('isDrawerOpen', false);
}

export const general = createReducer(INITIAL_STATE, {
  [ActionTypes.OPEN_DRAWER]: openDrawer,
  [ActionTypes.CLOSE_DRAWER]: closeDrawer,
});



// WEBPACK FOOTER //
// ./src/reducers/general.js